// @copyright  2006 - 2022 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    'progress_reports.title.main': 'Main Progress Report',

    'progress_reports.label.money_on_the_road': 'Money on the Road',
    'progress_reports.label.money_in_bank': 'Money in the Bank',
    'progress_reports.label.avg_daily_expense': 'Average Daily Expense',
    'progress_reports.label.days_to_bankruptcy': 'Days of Cash Left',

    'progress_reports.label.view_bank_accounts': 'View Bank Accounts',
    'progress_reports.label.view_purchases': 'View Purchases',
    'progress_reports.label.view_sales': 'View Sales',
    'progress_reports.label.total_earnings': 'Total earnings',
    'progress_reports.label.total_expenditure': 'Total expenditure',
    'progress_reports.label.total_cash': 'Total cash',
    'progress_reports.label.in_last': 'in last',
    'progress_reports.label.year': 'year',

    'progress_reports.message.no_data_heading': 'No data yet',
    'progress_reports.message.no_data_body': 'Start by adding expenses, invoices, or a bank account to see your progress report come to life.',
};
